import type { ColDef } from 'ag-grid-community'

/**
 * How many skeleton column cells to draw per row. Mirrors the real grid's
 * column count so Players (more columns) and Officials (fewer) each get a
 * plausible shape instead of one hardcoded number — but floored at 1 so an
 * empty/unresolved `columns` array (e.g. before column defs compute) still
 * renders something rather than a blank row.
 */
export const rosterGridSkeletonColumnCount = <TRow>(
  columns: ColDef<TRow>[]
): number => Math.max(1, columns.length)
